import { defineStore } from "pinia";
// import { ref } from "vue";
// import { useCldURLs } from "~/constants/apiv2.urls";
// // import { useURLs } from "~~/constants/api.urls";
// import { CLD_ENV } from "~~/constants/env";
import nuxtStorage from "nuxt-storage";
import { useCartStore } from "./CartStore";
export const useOrderStore = defineStore("order", () => {
  const cartStore =  useCartStore()

  const nuxtApp = useNuxtApp();
  const pending = ref(false);
  const orderHistory = ref([]);
  const countOrderHistory = ref(0);
  const deliverableOrders = ref([]);
  const totalDeliverables = ref(0);
  // Same set of lines as totalDeliverables, VAT included (per-line TAUX_TVA applied backend-side).
  // This is the figure a prepayment customer actually has to settle, so it is what Adyen charges.
  const totalDeliverablesWithVat = ref(0);
  // Shipping-cost booking (from /Shipping/add-shipping-cost), reported separately by the API so
  // the free-shipping/franco progress (measured on merchandise only) is not inflated by it.
  // Added on top of totalDeliverablesWithVat when computing the online-payment amount.
  const shippingCost = ref(0);
  const shippingCostWithVat = ref(0);
  const totalUnDeliverables = ref(0);
  const supplierOrderIds = ref([]);
  const opendDocs = ref([]);
  const accountingSituation = ref({
    "capt": "",
    "c_ID": "",
    "isBlocked": null,
    "name": "",
    "bookedBalance": 0,
    "balance": 0,
    "credit": 0,
    "overLimit": 0,
    "lastPosBal": "",
    "maxDaysOver": 0,
    "action": "",
    "action2": "",
    "colorCreditAmount": "",
    "color": ""
});

  const downloadOrderHistory = async ({ startDate, endDate }) => {
    const url = `${useCldURLs[CLD_ENV].account.download_history}?startDate=${startDate}&endDate=${endDate}`;

    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {},
    });
    if (data.value?.error) {
      throw new Error(data.value?.error || "ERROR_DOWNLOAD");
    }
    const downloadUrl = window.URL.createObjectURL(data.value);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute(
      "download",
      `order_history_${startDate}_to_${endDate}.zip`
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  const getOrderHistory = async (url, body) => {
    const { data } = await useFetchApi(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    });

    return data.value;
  };

  const getDropshipOrderHistory = async (url, body) => {
    const { data } = await useFetchApi(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    });

    return data.value;
  };


  const searchOrderHistory = async (params) => {
    const url = `${useCldURLs[CLD_ENV].account.search_order_history}${params}`;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return data.value;
  };
  const searchOrders = async (params) => {
    const url = `${useCldURLs[CLD_ENV].account.search_orders}${params}`;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return data.value;
  };
  const searchSupplierOrders = async () => {
    const url = `${useCldURLs[CLD_ENV].account.search_supplier}`;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    supplierOrderIds.value = Object.entries(data.value)
      .filter((x) => x[1] > 0)
      .map((x) => x[0].trim());
  };

  const getAllBackOrders = async (params) => {
    const url = `${useCldURLs[CLD_ENV].account.back_orders}${params}`;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return data.value;
  };
  const getDeliverableOrders = async (params) => {
    totalDeliverables.value = 0;
    totalDeliverablesWithVat.value = 0;
    shippingCost.value = 0;
    shippingCostWithVat.value = 0;
    // _ts cache-buster: the grid re-fetches this URL with identical params right after a
    // delivery option is triggered; without it a browser/proxy-cached response can keep the
    // freshly booked shipping cost invisible until a manual page reload.
    const url = `${useCldURLs[CLD_ENV].account.deliverable_orders}${params}_ts=${Date.now()}`;
    const { data, error } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    // useAsyncData swallows the throw and leaves data null on failure (timeout / 5xx).
    // Re-throw so the grid shows a real "failed to load" state instead of crashing on null.
    if (error.value) {
      throw error.value;
    }
    const payload = data.value || {};
    totalDeliverables.value = payload.totalDeliverables || 0;
    // Older API builds don't return the VAT-included total — fall back to the excl. VAT one so
    // the prepayment warning keeps working instead of silently reading 0.
    totalDeliverablesWithVat.value =
      payload.totalDeliverablesWithVat ?? payload.totalDeliverables ?? 0;
    // Older API builds don't return the shipping-cost fields — treat them as 0.
    shippingCost.value = +(payload.shippingCost ?? 0) || 0;
    shippingCostWithVat.value = +(payload.shippingCostWithVat ?? 0) || 0;
    deliverableOrders.value = payload.dxGrid || [];
    return payload.dxGrid || [];
  };

  const getDeliverableOrdersTotal = async (ctx) => {
    console.log("get-deliverable_orders_total ctx=", ctx);
    const isAuthenticated = useCookie("isAuthenticated").value;
    if (!isAuthenticated) {
      return false;
    }
    totalDeliverables.value = 0;
    const url = useCldURLs[CLD_ENV].account.deliverable_orders_total;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    totalDeliverables.value = +data.value;
    nuxtStorage.localStorage.setData("totalDeliverables", data.value, 60, "m");
    return data.value;
  };

  const getDeliverablesTotalFromStorage = async () => {
    const isAuthenticated = useCookie("isAuthenticated").value;
    if (!isAuthenticated) {
      // Ensure no cross-user leakage via localStorage when logged out
      try {
        nuxtStorage.localStorage.removeItem("totalDeliverables");
      } catch {}
      totalDeliverables.value = 0;
      return false;
    }
    const cachedData = nuxtStorage.localStorage.getData("totalDeliverables");
    if (cachedData !== null && cachedData !== undefined) {
      totalDeliverables.value = +cachedData;
      return cachedData;
    }
    return await getDeliverableOrdersTotal();
  };

  const getUnDeliverableOrders = async (params) => {
    totalUnDeliverables.value = 0;
    const url = `${useCldURLs[CLD_ENV].account.undeliverable_orders}${params}`;
    const { data, error } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (error.value) {
      throw error.value;
    }
    const payload = data.value || {};
    totalUnDeliverables.value = payload.totalDeliverables || 0;
    return payload.dxGrid || [];
  };
  const getOpendDocs = async (params) => {
    const url = `${useCldURLs[CLD_ENV].account.open_docs}${params}`;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    opendDocs.value = data.value?.data;
    return data.value;
  };
  const getAccountingSituation = async () => {
    const isAuthenticated = useCookie("isAuthenticated").value;
    if (!isAuthenticated) {
      return false;
    }
    const url = useCldURLs[CLD_ENV].account.accounting_situation;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    accountingSituation.value = data.value;
  };
  const getAccountingSituationLocalStorage = async () => {
    const isAuthenticated = useCookie("isAuthenticated").value;
    if (!isAuthenticated) {
      // Ensure no cross-user leakage via localStorage when logged out / before login
      try {
        nuxtStorage.localStorage.removeItem("accountingSituation");
        if (process.client) window.localStorage.removeItem("accountingSituation");
      } catch {}
      accountingSituation.value = {
        capt: "",
        c_ID: "",
        isBlocked: null,
        name: "",
        bookedBalance: 0,
        balance: 0,
        credit: 0,
        overLimit: 0,
        lastPosBal: "",
        maxDaysOver: 0,
        action: "",
        action2: "",
        colorCreditAmount: "",
        color: "",
      };
      return false;
    }

    // Get current user session marker to validate cached data ownership
    const currentUserMarker = process.client ? window.localStorage.getItem("currentUserSession") : null;

    const data = nuxtStorage.localStorage.getData("accountingSituation");
    if (data) {
      try {
        const parsed = JSON.parse(data);
        // Validate cached data belongs to current user session
        // If no session marker or c_ID doesn't match, invalidate cache
        if (parsed?.c_ID && currentUserMarker && parsed.c_ID === currentUserMarker) {
          accountingSituation.value = parsed;
          return;
        }
        // Cache is from different user session - clear it
        nuxtStorage.localStorage.removeItem("accountingSituation");
        if (process.client) window.localStorage.removeItem("accountingSituation");
      } catch {
        // If cache is corrupted, ignore it and re-fetch.
      }
    }

    await getAccountingSituation();
    // Store session marker with cached data
    if (accountingSituation.value?.c_ID && process.client) {
      window.localStorage.setItem("currentUserSession", accountingSituation.value.c_ID);
    }
    nuxtStorage.localStorage.setData(
      "accountingSituation",
      JSON.stringify(accountingSituation.value),
      10,
      "m"
    );
    
  };
  const reOpendOrder = async ({ docNumber, cartId }) => {
    const url = `${useCldURLs[CLD_ENV].order.re_open}?cartId=${cartId}&docNumber=${docNumber}`;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
 
    if (data.value && data.value.items?.length) {
      const sumQty = data.value.items
      .map((item) => +item.quantity)
      .reduce((prev, next) => prev + next);
      cartStore.setCart({cart:data.value, qty: sumQty});
    }

    return data.value;
  };
  const getShipmentLink = async ({ id, docType, docNumber }) => {
    const url = `${useCldURLs[CLD_ENV].account.shipment_link}?id=${id}&docType=${docType}&docNumber=${docNumber}`;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data.value;
  };



  const setAccountingSituation = () => {
    // Clear from both nuxt-storage AND raw localStorage to ensure complete clearing
    nuxtStorage.localStorage.removeItem("accountingSituation");
    nuxtStorage.localStorage.removeItem("totalDeliverables");
    if (process.client) {
      try { window.localStorage.removeItem("accountingSituation"); } catch {}
      try { window.localStorage.removeItem("totalDeliverables"); } catch {}
    }
    totalDeliverables.value = 0;
    totalDeliverablesWithVat.value = 0;
    shippingCost.value = 0;
    shippingCostWithVat.value = 0;
    accountingSituation.value = {
      "capt": "",
      "c_ID": "",
      "isBlocked": null,
      "name": "",
      "bookedBalance": 0,
      "balance": 0,
      "credit": 0,
      "overLimit": 0,
      "lastPosBal": "",
      "maxDaysOver": 0,
      "action": "",
      "action2": "",
      "colorCreditAmount": "",
      "color": ""
  }
  };
  return {
    getOrderHistory,
    downloadOrderHistory,
    getDeliverableOrders,
    getDeliverableOrdersTotal,
    getDeliverablesTotalFromStorage,
    getUnDeliverableOrders,
    getAccountingSituation,
    getAccountingSituationLocalStorage,
    setAccountingSituation,
    deliverableOrders,
    totalDeliverables,
    totalDeliverablesWithVat,
    shippingCost,
    shippingCostWithVat,
    totalUnDeliverables,
    searchOrderHistory,
    searchOrders,
    getAllBackOrders,
    reOpendOrder,
    opendDocs,
    getOpendDocs,
    orderHistory,
    countOrderHistory,
    searchSupplierOrders,
    supplierOrderIds,
    accountingSituation,
    getShipmentLink,
    getDropshipOrderHistory,
   
  };
});
